// Recalculate (one day) on a day too full to finish by the day's end time
// (or midnight) moves the stops that don't fit to the next day (Schedule.recalculateDay,
// 2026-10-28). This is what the person is told. Kept identical in
// andiamo-web and andiamo-places (src/Common).
export function movedToNextDayMessage(names) {
  const list = (names || []).filter(Boolean);
  if (list.length === 0) return null;
  const n = list.length;
  const shown = list.length > 4 ? `${list.slice(0, 4).join(", ")} and ${list.length - 4} more` : list.join(", ");
  return {
    title: `${n} stop${n === 1 ? "" : "s"} moved to the next day`,
    body: `This day can't fit everything before its end time, so ${shown} ${n === 1 ? "was" : "were"} moved to the start of the next day (after its own stops), keeping ${n === 1 ? "its" : "their"} length. Shorten some visits or remove a stop if you'd rather keep ${n === 1 ? "it" : "them"} on this day.`,
  };
}
